
































import { Prop, Component, Watch, Vue } from "vue-property-decorator";
import parseISO from "date-fns/parseISO";

import IconSchedule from "@/components/icons/IconSchedule.vue";
import { addLeadingZero } from "@/services/utils";

@Component({
  name: "Counter",
  components: {
    IconSchedule,
  },
})
export default class Counter extends Vue {
  timer = {};
  timeout: NodeJS.Timer | null = null;

  @Prop({ type: String, default: null })
  readonly promo_end!: string;

  get parsedEndDate() {
    try {
      return parseISO(this.promo_end);
    } catch (error) {
      return null;
    }
  }

  mounted() {
    this.countdownTimer();
    this.timeout = setInterval(() => this.countdownTimer(), 1000);
  }

  countdownTimer() {
    if (!this.parsedEndDate) return;
    const nowDate = new Date().getTime();
    const endDate = new Date(this.parsedEndDate).getTime();
    const diff = endDate - nowDate;
    const days = diff > 0 ? Math.floor(diff / (1000 * 60 * 60 * 24)) : 0;
    const hours = diff > 0 ? Math.floor(diff / (1000 * 60 * 60)) % 24 : 0;
    const minutes = diff > 0 ? Math.floor(diff / (1000 * 60)) % 60 : 0;

    if (diff) {
      this.timer = {
        days: days.toString(),
        hours: addLeadingZero(hours),
        minutes: addLeadingZero(minutes),
      };
    }
  }
}
